<template>
    <div class="big-play-button" @click="$emit('click')">
        <i class="sr-2 sr-v2-play" />
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
    .big-play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        width: 86px;
        height: 45px;
        background: #00e67e;
        background-color: rgba(43, 51, 63, .7);
        border-radius: 9px;
        border: 2px solid white;

        display: flex;
        align-items: center;
        justify-content: center;
        
        cursor: pointer;

        transition: all 0.4s ease;

        &:hover {
            background-color: rgba(115, 133, 159, .5);
        }

        i {
            color: #f1f1f1;
            font-size: 20px;
            padding-left: 2px;
        }
    }
</style>